import { makeStyles, Image, tokens, Link, Badge, Persona, Popover, PopoverTrigger, PopoverSurface, Button, Divider } from "@fluentui/react-components";
import { Outlet } from "react-router";

const useStyles = makeStyles({
    header: {
        "padding": "0.5rem",
        "display": "flex",
        "alignItems": "center",
        "gap": "0.5rem",
        "borderBottom": "1px solid " + tokens.colorNeutralStroke2,
        "height": "55px"
    },
    headerFlexBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "0.5rem",
        "width": "100%",

        "& div.header-item": {
            display: "flex",
            alignItems: "center",
            gap: "0.5rem"
        }
    },
    accountContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem"
    }
})

export default function OuterTemplate()
{
    const styles = useStyles();

    return <>
        <div className="outer-template">
            <header className={styles.header}>
                <div className={styles.headerFlexBox}>
                    <a href="/" title="Omnivend Home" style={{ "textDecoration": "none", "color": "inherit" }}>
                        <div className="header-item">
                            <Image src="/images/Omnivend_Logo.webp" alt="Omnivend Logo" style={{ "width": "100%", "maxWidth": "200px" }} />
                            <Badge size="extra-large" shape="rounded" appearance="filled" color="brand">ALPHA</Badge>
                        </div>
                    </a>
                    <div className="header-item">
                        <Popover>
                            <PopoverTrigger disableButtonEnhancement>
                                <Button appearance="transparent">
                                    <Persona name="John Doe" secondaryText="Store Owner" avatar={{ color: "colorful" }} textAlignment="center" />
                                </Button>
                            </PopoverTrigger>
                            <PopoverSurface>
                                <div className={styles.accountContainer}>
                                    <Persona name="John Doe" size="huge" secondaryText="Store Owner" tertiaryText="Unnamed Store" avatar={{ color: "colorful" }} textAlignment="center" />
                                    <Divider />
                                    <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
                                        <Link href="/settings">Change store settings</Link>
                                        <Link href="#">Manage another store</Link>
                                        <Link href="#">Logout</Link>
                                    </div>
                                </div>
                            </PopoverSurface>
                        </Popover>
                    </div>
                </div>
            </header>
            <Outlet />
        </div>
    </>
}